// @flow
import React from 'react';
import {Input} from 'reactstrap'
import AbstractField from "./AbstractField";

class StringField extends AbstractField {

    render() {
        const {addonsBefore, addonsAfter, ...props} = this.props;

        const field = <Input
            type="text"
            {...props}
        />;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}

export default StringField;
